import {
    getSimilarImageServerlessUrl,
    getMatchingImageServerlessUrl,
    getFittingImageServerlessUrl,
    getImageWithNoBackgroundServerlessUrl,
    getEditedImageServerlessUrl,
    getUpscaledImageServerlessUrl,
    getEnhancedImageServerlessUrl
} from '../constants'
import type {ImagesInfoMap, UserRequestInfo} from '@wix/document-services-types'
import {postForMedia} from '../utils'

export interface ImagesRequestBody<T> {
    images: Record<string, T>
    userRequestInfo?: UserRequestInfo
}

export interface CommonImageFetchParams {
    userImage: string
    height_RunwareFlux: string
    width_RunwareFlux: string
}

export interface MatchImageToPageParams extends CommonImageFetchParams {
    Site_Description: string
}

export interface RemoveImageBackgroundParams {
    imageUrl: string
}

export interface EditImageParams extends CommonImageFetchParams {
    editRequest: string
}

export interface UpscaleImageParams {
    imageUrl: string
}

export interface EnhanceImageParams {
    imageUrl: string
}

export const fetchSimilarImageUrls = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<CommonImageFetchParams>
): Promise<ImagesInfoMap> => postForMedia<ImagesInfoMap>(serverFacade, getSimilarImageServerlessUrl, requestBody)

export const fetchMatchingImages = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<MatchImageToPageParams>
): Promise<ImagesInfoMap> => postForMedia<ImagesInfoMap>(serverFacade, getMatchingImageServerlessUrl, requestBody)

export const fetchFittingImages = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<CommonImageFetchParams>
): Promise<ImagesInfoMap> => postForMedia<ImagesInfoMap>(serverFacade, getFittingImageServerlessUrl, requestBody)

export const fetchImagesWithNoBackground = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<RemoveImageBackgroundParams>
): Promise<ImagesInfoMap> =>
    postForMedia<ImagesInfoMap>(serverFacade, getImageWithNoBackgroundServerlessUrl, requestBody)

export const fetchEditedImages = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<EditImageParams>
): Promise<ImagesInfoMap> => postForMedia<ImagesInfoMap>(serverFacade, getEditedImageServerlessUrl, requestBody)

export const fetchUpscaledImages = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<UpscaleImageParams>
): Promise<ImagesInfoMap> => postForMedia<ImagesInfoMap>(serverFacade, getUpscaledImageServerlessUrl, requestBody)

export const fetchEnhancedImages = async (
    serverFacade: any,
    msid: string,
    requestBody: ImagesRequestBody<EnhanceImageParams>
): Promise<ImagesInfoMap> => postForMedia<ImagesInfoMap>(serverFacade, getEnhancedImageServerlessUrl, requestBody)

export type Fetcher<TParams> = (serverFacade: any, msid: string, params: TParams) => Promise<string>
